import { BasicsBaseApiV2 } from "../BasicsBaseApiV2";

export class ReportTemplateTypeApi extends BasicsBaseApiV2 {

    public get ControllerName(): any {
        return 'reportTemplateType';
    }

}